import React from 'react'

import { useFormContext } from 'react-hook-form'

import { LoadingBackdrop } from 'components/common'
import { Roles } from 'constants/index'
import { CreateAndUpdateSubDriverDtoInput, useGetDriverQuery } from 'generated/graphql'

import { SubDriverForm } from './SubDriverForm'

interface IProps {
  subDriverId: number | null
  subDriverRole: string | null
}

const UpdateSubDriver = (props: IProps) => {
  const { subDriverId, subDriverRole } = props
  const { reset } = useFormContext<CreateAndUpdateSubDriverDtoInput>()
  // Queries
  const { data: driverData, loading: driverLoading } = useGetDriverQuery({
    variables: { driverId: subDriverId },
  })

  React.useEffect(() => {
    if (!driverData?.driver) return

    const { driver } = driverData

    reset({
      ...driver,
      primaryDriverId: driver.primaryDriverId ?? undefined,
      role: subDriverRole || Roles.driverSubcontractor,
    })
  }, [driverData, subDriverRole, reset])

  return (
    <>
      <SubDriverForm
        disableRoleSelection={!subDriverRole}
        deactivatedByAdmin={driverData?.driver?.deactivatedByAdmin ?? undefined}
        primaryDriverId={driverData?.driver?.primaryDriverId ?? undefined}
      />
      <LoadingBackdrop loading={driverLoading} />
    </>
  )
}

export default UpdateSubDriver
